import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Lock, FileText, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { levelStyle } from "@/lib/constants";
import MissionSheet from "@/pages/MissionSheet";

export default function MesFiches() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const [state, setState] = useState({ loading: true, ok: false, school: "", fiches: [] });
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!code) { setState({ loading: false, ok: false, school: "", fiches: [] }); return; }
    api.get(`/fiches/access/${code}`)
      .then((r) => setState({ loading: false, ok: true, school: r.data.school, fiches: r.data.fiches }))
      .catch(() => setState({ loading: false, ok: false, school: "", fiches: [] }));
  }, [code]);

  if (state.loading) return <div className="max-w-3xl mx-auto px-6 py-24 text-center text-slate-400">Chargement…</div>;

  if (!state.ok) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="fiches-access-denied">
        <span className="grid place-items-center w-16 h-16 rounded-2xl bg-rose-100 text-rose-500 mx-auto mb-6"><Lock className="w-8 h-8" /></span>
        <h1 className="font-heading font-black text-3xl text-slate-900">Accès réservé</h1>
        <p className="text-slate-500 mt-3">Ce lien n'est pas valide ou a expiré. Les fiches de mission sont accessibles via le lien envoyé par email après la validation de votre réservation.</p>
      </div>
    );
  }

  if (selected) {
    return (
      <div>
        <div className="no-print max-w-5xl mx-auto px-4 sm:px-6 pt-6">
          <button onClick={() => setSelected(null)} className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 font-semibold text-sm" data-testid="fiches-back-list"><ArrowLeft className="w-4 h-4" /> Mes fiches</button>
        </div>
        <MissionSheet fiche={selected} />
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-sky-600">Espace ressources</span>
      <h1 className="font-heading font-black text-4xl sm:text-5xl text-slate-900 mt-2">Vos fiches de mission</h1>
      <p className="mt-4 text-slate-600">{state.school ? `Bonjour ${state.school} ! ` : ""}Voici les fiches des ateliers que vous avez réservés.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-8" data-testid="my-fiches-list">
        {state.fiches.map((f) => {
          const s = levelStyle(f.level);
          return (
            <button key={f.slug} onClick={() => setSelected(f)} data-testid={`my-fiche-${f.slug}`}
              className="text-left flex items-center justify-between gap-4 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 hover:border-sky-300 hover:shadow-md transition-[border-color,box-shadow]">
              <div className="flex items-center gap-4 min-w-0">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-sky-100 text-sky-600 shrink-0"><FileText className="w-6 h-6" /></span>
                <div className="min-w-0">
                  <p className="font-heading font-bold text-slate-900 truncate">{f.title}</p>
                  <span className={`inline-block text-xs font-bold px-2 py-0.5 rounded-full mt-1 ${s.bg} ${s.text}`}>{s.label}</span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
